import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8457e5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_CheckOutlined = _resolveComponent("CheckOutlined")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 各版本功能及定价 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_table, {
        tableLayout: "fixed",
        columns: $data.table.column,
        "data-source": $data.table.data,
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD)?'default':'small',
        pagination: false,
        "row-class-name": (record,index)=>(index%2===1?'table_color':null)
      }, {
        bodyCell: _withCtx(({column,value}) => [
          (column.key==='name')
            ? (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(value), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (['base','specialty','enterprise'].indexOf(column.key)>=0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (typeof value==='boolean')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      value
                        ? (_openBlock(), _createBlock(_component_CheckOutlined, {
                            key: 0,
                            style: _normalizeStyle({color:_ctx.$Enum.ColorEnum.Success,fontSize:'18px'})
                          }, null, 8 /* PROPS */, ["style"]))
                        : (_openBlock(), _createBlock(_component_CloseOutlined, {
                            key: 1,
                            style: {color:'#aaaaaa'}
                          }))
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(value), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["columns", "data-source", "size", "row-class-name"]),
      _createVNode(_component_a_space, {
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$RQ.GoGSS()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 免费试用 ")
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    ])
  ]))
}